import axios from "axios";
import env from "../config";
// import { setNotification, useNotifcation } from 'context/notification'
import { ReqMethods, ResponseStatus } from "../enums";
// import { useAuth, useLogout } from './auth'

const BASE_URL = `${env.API_URL}`;

function useServiceHandler() {
  // const [, dispatch] = useNotifcation()
  // const Logout = useLogout()

  return (fn) =>
    async (
      method,
      path,
      { query, payload, token, apiKey, toaster, message, error } = {}
    ) => {
      try {
        const res = await fn(method, path, { query, payload, token, apiKey });
        // console.log("API - RESPONSE", res, toaster, message, error);
        // toaster &&
        //   setNotification(dispatch, {
        //     open: true,
        //     message: message || res.data.message,
        //     severity: 'success',
        //     title: 'Success',
        //   })

        return { response: res.data };
      } catch (err) {
        // console.log("API- ERROR", err.response?.data || err);

        // expire error : jwt expired
        if (
          err.response &&
          err.response.status === ResponseStatus.UNAUTHORIZED
        ) {
          // setNotification(dispatch, {
          //   open: true,
          //   message: error || 'session expired',
          //   title: 'Error',
          //   severity: 'error',
          // })
          // setTimeout(Logout, 4000)
          return { error: err.response?.data || err };
        }

        const customError = err.response?.data?.error
          ? `${err.response?.data?.message} \n${err.response?.data?.error}`
          : err.response?.data?.message;

        // toaster &&
        //   setNotification(dispatch, {
        //     open: true,
        //     message: error || customError || err.message,
        //     severity: 'error',
        //     title: 'Error',
        //   })
        return { error: err.response ? err.response.data : err };
      }
    };
}

function useCallService() {
  // const authToken = useAuth()
  const serviceHandler = useServiceHandler();

  const CallService = (
    method,
    path,
    { query, payload, token = true, apiKey = null }
  ) => {
    const pathname = query ? `${path}?${query}` : path;
    const config = {};

    // if (token) config.headers = { 'x-auth-token': `Bearer ${authToken || token}` }
    // if (apiKey) config.headers = { apiKey }

    const details = {};

    if (payload) details.payload = payload;
    details.config = config;

    return axios[method](pathname, ...Object.values(details));
  };

  return serviceHandler(CallService);
}

function useAppServices() {
  const { GET, POST, PUT, DELETE } = ReqMethods;
  const CallService = useCallService();

  /**
    Option for service is the object that could has the following properties
    query, payload, token, apiKey
  */

  const APIs = {
    auth: {
      integrate_app: (options) =>
        CallService(POST, `${BASE_URL}/auth/integrate_app`, options),
      integrate_support_app: (options) =>
        CallService(POST, `${BASE_URL}/auth/integrate_support_app`, options),
      integrate_customizer_module_app: (options) =>
        CallService(POST, `${BASE_URL}/auth/integrate_customizer_module_app`, options),
      login: (options) => CallService(POST, `${BASE_URL}/auth/login`, options),
      superadmin_login: (options) =>
        CallService(POST, `${BASE_URL}/auth/superadmin_login`, options),
      CreateTeam: (options) =>
        CallService(POST, `${BASE_URL}/auth/team`, options),
      UpdateTeam: (options) =>
        CallService(PUT, `${BASE_URL}/auth/team`, options),
      DeleteTeam: (options) => CallService(DELETE, `${BASE_URL}/user`, options),
    },
    webhook: {
      qr_code: (options) =>
        CallService(GET, `${BASE_URL}/webhook/qr_code`, options),
      bulkmessage: (options) =>
        CallService(POST, `${BASE_URL}/webhook/bulkmessage`, options),
      getdashboard_data: (options) =>
        CallService(GET, `${BASE_URL}/webhook/getdashboard_data`, options),
      getloginactivity_data: (options) =>
        CallService(GET, `${BASE_URL}/webhook/getloginactivity_data`, options),
      toggle_feedback_requested: (options) =>
        CallService(PUT, `${BASE_URL}/account/toggle_feedback_requested`, options),
            get_ghl_custom_menu_links: (options) =>
        CallService(GET, `${BASE_URL}/webhook/get_ghl_custom_menu_links`, options),
                create_ghl_custom_menu_link: (options) =>
        CallService(POST, `${BASE_URL}/webhook/create_ghl_custom_menu_link`, options),
                 update_ghl_custom_menu_link: (options) =>
        CallService(PUT, `${BASE_URL}/webhook/update_ghl_custom_menu_link`, options),
    },
    top_navigation: {
      get: (options) => CallService(GET, `${BASE_URL}/top_navigation`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/top_navigation`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/top_navigation/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/top_navigation`, options),
      change_sorting: (options) =>
        CallService(POST, `${BASE_URL}/top_navigation/change_sorting`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/top_navigation`, options),
    },
    LoginPageBuilder: {
      create: (options) => CallService(POST, `${BASE_URL}/login_page_builder`, options),
      get: (options) => CallService(GET, `${BASE_URL}/login_page_builder`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/login_page_builder/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/login_page_builder`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/login_page_builder`, options),
  },
    menu_edits: {
      get: (options) => CallService(GET, `${BASE_URL}/menu_edits`, options),
      create: (options) => CallService(POST, `${BASE_URL}/menu_edits`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/menu_edits/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/menu_edits`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/menu_edits`, options),
    },
    header_buttons: {
      get: (options) => CallService(GET, `${BASE_URL}/header_buttons`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/header_buttons`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/header_buttons/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/header_buttons`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/header_buttons`, options),
    },
    launchPad: {
      get: (options) => CallService(GET, `${BASE_URL}/launchPad`, options),
      create: (options) => CallService(POST, `${BASE_URL}/launchPad`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/launchPad/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/launchPad`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/launchPad`, options),
    },
    userSettings: {
      get: (options) => CallService(GET, `${BASE_URL}/userSettings`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/userSettings`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/userSettings/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/userSettings`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/userSettings`, options),
    },
    opportunities: {
      get: (options) => CallService(GET, `${BASE_URL}/opportunities`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/opportunities`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/opportunities/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/opportunities`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/opportunities`, options),
    },
    setting_menu: {
      get: (options) => CallService(GET, `${BASE_URL}/setting_menu`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/setting_menu`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/setting_menu/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/setting_menu`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/setting_menu`, options),
    },
    sidenav_customizer_main_level: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/sidenav_customizer_main_level`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/sidenav_customizer_main_level`, options),
      filter: (options) =>
        CallService(
          GET,
          `${BASE_URL}/sidenav_customizer_main_level/filter`,
          options
        ),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/sidenav_customizer_main_level`, options),
      delete: (options) =>
        CallService(
          DELETE,
          `${BASE_URL}/sidenav_customizer_main_level`,
          options
        ),
    },
    sidenav_customizer_saas_level: {
      getPlans: (options) =>
        CallService(
          GET,
          `${BASE_URL}/sidenav_customizer_saas_level/get-plans`,
          options
        ),
      get: (options) =>
        CallService(GET, `${BASE_URL}/sidenav_customizer_saas_level`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/sidenav_customizer_saas_level`, options),
      duplicate: (options) =>
        CallService(
          POST,
          `${BASE_URL}/sidenav_customizer_saas_level/duplicate`,
          options
        ),
      filter: (options) =>
        CallService(
          GET,
          `${BASE_URL}/sidenav_customizer_saas_level/filter`,
          options
        ),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/sidenav_customizer_saas_level`, options),
      delete: (options) =>
        CallService(
          DELETE,
          `${BASE_URL}/sidenav_customizer_saas_level`,
          options
        ),
    },
    sidenav_customizer_custom_level: {
      get: (options) =>
        CallService(
          GET,
          `${BASE_URL}/sidenav_customizer_custom_level`,
          options
        ),
      getLocations: (options) =>
        CallService(
          GET,
          `${BASE_URL}/sidenav_customizer_custom_level/get-locations`,
          options
        ),
      getGhlLocations: (options) =>
        CallService(
          GET,
          `${BASE_URL}/sidenav_customizer_custom_level/get-ghl-lcoations`,
          options
        ),
      create: (options) =>
        CallService(
          POST,
          `${BASE_URL}/sidenav_customizer_custom_level`,
          options
        ),
      duplicate: (options) =>
        CallService(
          POST,
          `${BASE_URL}/sidenav_customizer_custom_level/duplicate`,
          options
        ),

      filter: (options) =>
        CallService(
          GET,
          `${BASE_URL}/sidenav_customizer_custom_level/filter`,
          options
        ),
      update: (options) =>
        CallService(
          PUT,
          `${BASE_URL}/sidenav_customizer_custom_level`,
          options
        ),
      delete: (options) =>
        CallService(
          DELETE,
          `${BASE_URL}/sidenav_customizer_custom_level`,
          options
        ),
    },
    contactButtonLink: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/contactButtonLink`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/contactButtonLink`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/contactButtonLink/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/contactButtonLink`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/contactButtonLink`, options),
    },
    contactButtons: {
      get: (options) => CallService(GET, `${BASE_URL}/contact_button`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/contact_button`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/contact_button/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/contact_button`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/contact_button`, options),
    },
    contact_buttons_group: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/contact_buttons_group`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/contact_buttons_group`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/contact_buttons_group/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/contact_buttons_group`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/contact_buttons_group`, options),
    },
    agency: {
      get: (options) => CallService(GET, `${BASE_URL}/agency`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/agency/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/agency`, options),
      getProducts: (options) =>
        CallService(PUT, `${BASE_URL}/agency/getproducts`, options),
    },
    knowledgebase_category: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_category`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/knowledgebase_category`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_category/filter`, options),
      get_agency_categories: (options) =>
        CallService(
          GET,
          `${BASE_URL}/knowledgebase_category/get_agency_categories`,
          options
        ),
      data_visibility: (options) =>
        CallService(
          POST,
          `${BASE_URL}/knowledgebase_category/data_visibility`,
          options
        ),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/knowledgebase_category`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/knowledgebase_category`, options),
    },
    knowledgebase_sub_category: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_sub_category`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/knowledgebase_sub_category`, options),
      filter: (options) =>
        CallService(
          GET,
          `${BASE_URL}/knowledgebase_sub_category/filter`,
          options
        ),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/knowledgebase_sub_category`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/knowledgebase_sub_category`, options),
    },
    knowledgebase_article: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_article`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/knowledgebase_article`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_article/filter`, options),
       get_agency_articles: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_article/get_agency_articles`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/knowledgebase_article`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/knowledgebase_article`, options),
    },
    knowledgebase_customization: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_customization`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/knowledgebase_customization`, options),
      create_custom_menu_link: (options) =>
        CallService(
          POST,
          `${BASE_URL}/knowledgebase_customization/create_custom_menu_link`,
          options
        ),
      filter: (options) =>
        CallService(
          GET,
          `${BASE_URL}/knowledgebase_customization/filter`,
          options
        ),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/knowledgebase_customization`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/knowledgebase_customization`, options),
    },
    knowledgebase_language: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_language`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/knowledgebase_language`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_language/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/knowledgebase_language`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/knowledgebase_language`, options),
    },
    theme_customization: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/theme_customization`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/theme_customization`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/theme_customization/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/theme_customization`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/theme_customization`, options),
    },
    support: {
      get_tickets: (options) =>
        CallService(GET, `${BASE_URL}/support/get_tickets`, options),
      get_tickets_with_messages: (options) =>
        CallService(
          GET,
          `${BASE_URL}/support/get_tickets_with_messages`,
          options
        ),
      get_single_ticket_with_messages: (options) =>
        CallService(
          GET,
          `${BASE_URL}/support/get_single_ticket_with_messages`,
          options
        ),
      create_ticket: (options) =>
        CallService(POST, `${BASE_URL}/support/create_ticket`, options),
      create_custom_menu_link: (options) =>
        CallService(
          POST,
          `${BASE_URL}/support/create_custom_menu_link`,
          options
        ),
    },
    ghlapis: {
      getcontacts: (options) =>
        CallService(GET, `${BASE_URL}/ghlapis/getcontacts`, options),
      make_wallet_charge: (options) =>
        CallService(POST, `${BASE_URL}/ghlapis/make_wallet_charge`, options),
    },
    utils: {
      upload_image: (options) =>
        CallService(POST, `${BASE_URL}/utils/upload/image`, options),
    },
    services: {
      ghl: {
        call_service: (options) =>
          CallService(POST, `${BASE_URL}/services/ghl/`, options),
      },
    },
    ghl_article: {
      get: (options) => CallService(GET, `${BASE_URL}/ghl_article`, options),
      getOne: (options) => CallService(GET, `${BASE_URL}/ghl_article/${options?.id}`, options),
      getCategories: (options) => CallService(GET, `${BASE_URL}/ghl_article/categories`, options),
      getFolders: (options) => CallService(GET, `${BASE_URL}/ghl_article/folders`, options),
      seed: (options) => CallService(POST, `${BASE_URL}/ghl_article/seed`, options),
      deleteAll: (options) => CallService(DELETE, `${BASE_URL}/ghl_article`, options),
    },
  };

  return APIs;
}
const useUploadImage = () => {
  const AppService = useAppServices();
  return ({ toaster, file, desiredPath }) => {
    const form = new FormData();
    form.append("image", file, file.name);
    return AppService.utils.upload_image({
      toaster,
      payload: form,
      query: `desiredPath=${desiredPath}`,
    });
  };
};
export { useAppServices, useCallService, useUploadImage };
